import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const DeleteAllPopup = ({ deleteSeries, setOpenDeletePopup, openDeletePopup }) => {
  const handleClose = () => {
    setOpenDeletePopup(false);
  };

  const handleConfirm = () => {
    setOpenDeletePopup(false);
    deleteSeries();
    handleClose();
  };

  return (
    <div>
      <Dialog
        open={ openDeletePopup }
        onClose={ handleClose }
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            Are you sure you want to delete all the series appointments?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={ handleClose }>
            No
          </Button>
          <Button onClick={ handleConfirm } autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteAllPopup;
